const breakpoints = {
    xs: 320,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1440,
};

/**
 * Check the current screen matches which breakpoint
 * window.mq({
 *      callback: () => {}.
 *      from: 'md',
 *      to: 'lg',
 * })
 */
window.mq = function({ callback, from, to }) {
    const fromPoint = breakpoints[from] || null;
    const toPoint = breakpoints[to] - 1 || null;

    const fromMatch = fromPoint ? `(min-width: ${fromPoint}px)` : null;
    const toMatch = toPoint ? `(max-width: ${toPoint}px)` : null;

    let match = null;
    if (fromMatch && toMatch) {
        match = `${fromMatch} and ${toMatch}`;
    } else if (fromMatch || toMatch) {
        match = fromMatch || toMatch;
    } else {
        return;
    }

    if (match && window.matchMedia(match).matches) {
        callback();
    }
}